export default "/images/vendor/flag-icon-css/flags/1x1/za.svg?3c71a2a22271a414dd3d3b34e95364d3";